import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AdminUserModel } from '../shared/models/admin-user-model';
import { AdminUserFilterModel } from '../shared/models/admin-user-filter-model';
import { SettingsService } from '../shared/services/settings.service';
import { ConfigurationService } from '@admin/shared/services/configuration.service';
import { PagingFilter } from '@admin/shared/models/paging-filter.model';
import { TableModule } from 'primeng/table';
import { PermissionModel } from '@admin/shared/models/permission-model';
import { FeatureModel } from '@admin/shared/models/feature-model';

@Component({
  selector: 'hr-admin-users',
  templateUrl: './admin-users.component.html',
  styleUrls: ['./admin-users.component.less'],
  standalone: false,
})
export class AdminUsersComponent implements OnInit {
  public adminUsers: AdminUserModel[];

  public filterPagingWrapper: PagingFilter<AdminUserFilterModel>;

  constructor(
    private settingsService: SettingsService,
    private config: ConfigurationService
  ) {
    this.filterPagingWrapper = new PagingFilter(new AdminUserFilterModel());
  }

  ngOnInit() {
    let config = this.config.getCachedConfig();
    this.loadAdminUsers();
  }

  public loadAdminUsers() {
    this.settingsService
      .ListAdminUsers(this.filterPagingWrapper)
      .subscribe((data) => {
        this.adminUsers = data.items;
      });
  }
}
